import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1005Status: 'idle',
    startProcess1005Error: undefined as any,
    loadUserParamsProcess1005Status: 'idle',
    loadUserParamsProcess1005Error: undefined as any,

    process1005List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1005 = createAsyncThunk('process1005Slice/startProcess1005', async ({ process1005 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1005/`,
        prepareData(process1005),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1005Status } = getState().process1005Slice
        return startProcess1005Status !== 'pending'
    }
})

export const loadUserParamsProcess1005 = createAsyncThunk('process1005Slice/loadUserParamsProcess1005', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1005/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1005Status } = getState().process1005Slice
        return loadUserParamsProcess1005Status !== 'pending'
    }
})

const Process1005Slice = createSlice({
    name: 'process1005Slice',
    initialState,
    reducers: {
        resetstartProcess1005: (state) => {
            state.job = undefined
            state.startProcess1005Error = undefined
        },
        resetstartProcess1005Error: (state) => {
            state.startProcess1005Error = undefined
        },
        resetloadUserParamsProcess1005: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1005Error = undefined
        },
        resetloadUserParamsProcess1005Error: (state) => {
            state.loadUserParamsProcess1005Error = undefined
        },
        removeFromProcess1005ListById: (state, action) => {
            state.process1005List = state.process1005List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1005ListByIds: (state, action) => {
            state.process1005List = state.process1005List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1005List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1005Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1005List = []
            state.startProcess1005Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1005.pending, (state) => {
            state.startProcess1005Status = 'pending'
            state.startProcess1005Error = undefined
        })
        builder.addCase(startProcess1005.fulfilled, (state, action) => {
            state.startProcess1005Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1005.rejected, (state, action) => {
            state.startProcess1005Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1005Error = action.error.message
            } else {
                state.startProcess1005Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1005.pending, (state) => {
            state.loadUserParamsProcess1005Status = 'pending'
            state.loadUserParamsProcess1005Error = undefined
        })
        builder.addCase(loadUserParamsProcess1005.fulfilled, (state, action) => {
            state.loadUserParamsProcess1005Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1005.rejected, (state, action) => {
            state.loadUserParamsProcess1005Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1005Error = action.error.message
            } else {
                state.loadUserParamsProcess1005Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1005,
    resetstartProcess1005Error,
    resetloadUserParamsProcess1005,
    resetloadUserParamsProcess1005Error,
    removeFromProcess1005ListById,
    removeFromProcess1005ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1005Slice.actions
export default Process1005Slice.reducer
